import Header from 'components/modules/Header/Header';
import SubHeader from 'components/modules/Header/SubHeader';
import Sidebar from 'components/modules/Sidebar/Sidebar';
import styles from './Default.module.scss';
// import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type Props = {
  children: React.ReactNode;
};

// const Default = ({ children }: Props) => (
//   <main className="bg-blue">
//     <Header />

//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-md-2">
//           <Sidebar />
//         </div>
//         <div className="col-md-10">
//           <div className="row">
//             {children}
//           </div>
//         </div>
//       </div>
//     </div>
//     <ToastContainer />
//   </main>
// );

const Default = ({ children }: Props) => (
  <main className="bg-blue">
    <Header />
    <div className="wrapper" style={{marginTop: '70px'}}>
      <Sidebar />
      
      <div id="content">
        <div className="container-fluid">
          <div className="row">
            {children}
          </div>

        </div>
      </div>
    </div>
  </main>
);
export default Default;
